/**
 * Host of this environment's collab worker (the Yjs server in `party/`).
 *
 * There is one collab deployment per environment. Until 2026-09 there were two
 * and `projects.collab_backend` picked between them per project; every room has
 * since moved to this one. docs/collab-migration/ has the history.
 *
 * Next.js only inlines env vars that are referenced statically, so the var is
 * read as a literal `process.env.X` expression, never via dynamic lookup.
 */
export function collabHost(): string {
  const host = process.env.NEXT_PUBLIC_COLLAB_CF_HOST
  if (!host) {
    throw new Error('NEXT_PUBLIC_COLLAB_CF_HOST is not configured')
  }
  return host
}
